<template>
  <div id="mqttStatusMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>设备</el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>Mqtt日志</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户::">
            <el-select v-model="pageSearch.fCustID"
                       clearable
                       filterable
                       placeholder="请选择客户"
                       style="width:250px;">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init(1,'')">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-search"
                       @click="init(1,0)">正常</el-button>
            <el-button type="danger"
                       size="small"
                       icon="el-icon-search"
                       @click="init(1,1)">异常</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  :row-class-name="tableRowClassName"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           align="right"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCltTime"
                           label="客户端时间"
                           width="160">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fPriIP"
                           width="125"
                           label="IP">
          </el-table-column>
          <el-table-column prop="fProgName"
                           label="程序名称">
          </el-table-column>
          <el-table-column prop="fProgVer"
                           align="right"
                           width="110"
                           label="程序版本">
          </el-table-column>
          <el-table-column prop="fMQTTSvr"
                           label="MQTT服务器">
          </el-table-column>
          <el-table-column prop="fPayName"
                           label="电子支付">
          </el-table-column>
          <el-table-column prop="fMQTTStatus"
                           width="100"
                           label="MQTT状态"
                           :formatter="rowFormatter">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { device } from '../../api/device'
import * as park from '../../api/park'
import * as user from '../../api/user'
export default {
  data () {
    return {
      is_export: false,
      tableHeight: 0,
      loading: false,
      pageData: [],
      msg_tip: '',
      cust_list: [],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        isMqtt: true,
        searchKeyWord: '',
        deviceType: '',
        fCustID: '',
        fIsExp: ''
      }
    }
  },
  methods: {
    init (index, fIsExp) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.pageSearch.fIsExp = fIsExp
      this.loading = true
      device.custDevPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：加载客户设备信息失败')
          }
        }
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fMQTTStatus === '0') {
        return 'warning-row'
      }
      return ''
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex, this.pageSearch.fIsExp)
    },
    handleCurrentChange (val) {
      this.init(val, this.pageSearch.fIsExp)
    },
    loadCust () {
      park.getCustByGroup().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            // this.init()
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   // this.init()
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    rowFormatter (row, column, cellValue, index) {
      if (cellValue === '1') {
        return '已连接'
      } else {
        return '未连接/异常'
      }
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 210
      obj.tableHeight = clientHeight
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 74000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.loadCust()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#mqttStatusMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#mqttStatusMain .el-dialog__title {
  color: white;
}
#mqttStatusMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#mqttStatusMain .el-dialog__body {
  padding: 10px 10px 10px 10px;
}
#mqttStatusMain .el-input.is-disabled .el-input__inner {
  color: #606266;
}
#mqttStatusMain .warning-row {
  color: #f56c6c;
}
#mqttStatusMain .tip span {
  padding-right: 10px;
  font-weight: bold;
  color: #ccc;
}
#mqttStatusMain .tip span.msg_value {
  padding-right: 0px;
  color: darkseagreen;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 10px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 300px;
}
.tip {
  text-align: center;
  position: absolute;
  top: 12px;
  right: 40px;
}
.log_search {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/device/mqttStatusMain.vue